(function(){
  var toastEl, timer;
  function toast(msg){
    toastEl = toastEl || document.getElementById('toast');
    if(!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(timer); timer = setTimeout(function(){ toastEl.classList.remove('show'); }, 2400);
  }
  window.bbToast = toast;

  // mobile menu
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-menu-toggle]');
    if(!t) return;
    var h = t.closest('.header'); var open = h.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open);
  });

  // ajax add to bag
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ajax-cart]');
    if(!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if(btn) btn.disabled = true;
    fetch(window.routes.cart_add_url + '.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:new FormData(form) })
      .then(function(r){ return r.json().then(function(j){ return { ok:r.ok, j:j }; }); })
      .then(function(res){
        if(!res.ok){ toast(res.j.description || 'That one could not be added.'); return; }
        return fetch(window.routes.cart_url + '.js').then(function(r){ return r.json(); }).then(function(cart){
          document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
          toast('Added to your haul!');
        });
      })
      .catch(function(){ form.submit(); })
      .finally(function(){ if(btn) btn.disabled = false; });
  });

  // variant picker
  document.addEventListener('change', function(e){
    var sel = e.target.closest('[data-variant-select]');
    if(!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var scope = sel.closest('[data-product]');
    var price = scope.querySelector('[data-price]');
    if(price) price.innerHTML = opt.getAttribute('data-price-html');
    var btn = scope.querySelector('[data-add-btn]');
    if(btn){
      var available = opt.getAttribute('data-available') === 'true';
      btn.disabled = !available;
      var label = btn.querySelector('[data-btn-label]') || btn;
      label.textContent = available ? btn.getAttribute('data-label') : 'Sold out';
      var bp = btn.querySelector('[data-btn-price]');
      if(bp){ bp.textContent = opt.getAttribute('data-price-money'); bp.hidden = !available; }
    }
    var save = scope.querySelector('[data-save]');
    if(save){
      var s = opt.getAttribute('data-save-money');
      save.hidden = !s; save.textContent = s ? 'Save ' + s : '';
    }
  });

  // product thumbnails swap the main image
  document.addEventListener('click', function(e){
    var th = e.target.closest('[data-thumb]');
    if(!th) return;
    var scope = th.closest('[data-product]');
    var img = scope && scope.querySelector('.pp-main img');
    if(!img) return;
    img.removeAttribute('srcset'); img.src = th.getAttribute('data-src');
    scope.querySelectorAll('[data-thumb]').forEach(function(b){ b.removeAttribute('aria-current'); });
    th.setAttribute('aria-current', 'true');
  });

  // ships-by and arrival dates (skips weekends)
  function addBusinessDays(d, n){
    d = new Date(d);
    while(n > 0){ d.setDate(d.getDate() + 1); if(d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function fmt(d, wd){ return d.toLocaleDateString('en-US', wd ? { weekday:'short', month:'short', day:'numeric' } : { month:'short', day:'numeric' }); }
  document.querySelectorAll('[data-ship]').forEach(function(box){
    var now = new Date();
    var p = +box.getAttribute('data-process'), mn = +box.getAttribute('data-min'), mx = +box.getAttribute('data-max');
    var by = box.querySelector('[data-ship-by]'), arr = box.querySelector('[data-arrive]');
    if(by) by.textContent = fmt(addBusinessDays(now, p), true);
    if(arr) arr.textContent = fmt(addBusinessDays(now, mn)) + ' - ' + fmt(addBusinessDays(now, mx));
  });

  // sale countdown (only shows when a real end date is set)
  document.querySelectorAll('[data-sale-end]').forEach(function(bar){
    var end = new Date(bar.getAttribute('data-sale-end')).getTime();
    var clock = bar.querySelector('[data-timer]');
    if(isNaN(end) || end <= Date.now()) return;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if(s === 0){ bar.hidden = true; clearInterval(iv); return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      clock.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s % 60) + 's';
    }
    var iv = setInterval(tick, 1000); tick(); bar.hidden = false;
  });
})();

